import { useState } from "react";
import SidebarSection from "./SidebarSection";
import ContactItem from "./ContactItem";
import { photoUrl, photoAlt, contact, skills, languages, certifications } from "../../data/cvData";

// Foto circular con respaldo: si la imagen no carga (ruta aún no configurada),
// muestra las iniciales para no dejar un ícono de imagen rota.
function Photo() {
  const [failed, setFailed] = useState(false);
  if (failed || !photoUrl) {
    return (
      <div className="cv-photo cv-photo--fallback" aria-label={photoAlt} role="img">
        HD
      </div>
    );
  }
  return (
    <img
      className="cv-photo"
      src={photoUrl}
      alt={photoAlt}
      onError={() => setFailed(true)}
    />
  );
}

export default function CvSidebar() {
  return (
    <aside className="cv-sidebar">
      <Photo />

      <SidebarSection title="Contacto">
        <ul className="cv-contact-list">
          {contact.map((c) => (
            <ContactItem key={c.icon} icon={c.icon} label={c.label} href={c.href} />
          ))}
        </ul>
      </SidebarSection>

      <SidebarSection title="Habilidades">
        {skills.map((s) => (
          <p
            key={s.category}
            className={s.highlight ? "cv-skill cv-skill--highlight" : "cv-skill"}
          >
            <strong className="cv-skill-cat">{s.category}:</strong> {s.items}
          </p>
        ))}
      </SidebarSection>

      <SidebarSection title="Idiomas">
        {languages.map((l) => (
          <p key={l.name} className="cv-lang">
            <strong>{l.name}</strong> — {l.level}
          </p>
        ))}
      </SidebarSection>

      <SidebarSection title="Certificaciones">
        {certifications.map((c) => (
          <p key={c.name} className="cv-cert">
            {c.name} — {c.issuer}
          </p>
        ))}
      </SidebarSection>
    </aside>
  );
}
